export default {"src":"/_next/static/media/okta-dark.ed6f747e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};